import {Component, OnInit, Input, ChangeDetectorRef, SimpleChanges, Output} from '@angular/core';
import {LocalStorageService} from 'ngx-webstorage';
import {BreakdownService} from './breakdown.service';
import {ActivatedRoute, Router} from '@angular/router';
import {UserInfoService} from '../../services/user-info.service';
import {Breakdown} from 'src/app/model/quote/breakdown/breakdown.model';
import {environment} from '../../../environments/environment';
import {EventEmitter} from 'events';

@Component({
  selector: 'app-breakdown',
  templateUrl: './breakdown.component.html',
  styleUrls: ['./breakdown.component.css']
})

export class BreakdownComponent implements OnInit {
  authDetails: string = '';
  selectedIndex = 0;
  @Input() quote;
  fullDetailsTab = false;
  statementOfFactsTab = false;
  paymentDetails = false;
  submission = false;
  staticData;
  apiModelObject;
  modelObject = new Breakdown();
  /** Stores the original policy id when loading a policy for MTA/Cancellation so child saves can reference it. */
  originalPolicyId: string | null = null;
  // urlID = this.route.snapshot.params.id;

  constructor(
    private breakdownService: BreakdownService,
    private route: ActivatedRoute,
    private router: Router,
    private userInfoService: UserInfoService,
    private cd: ChangeDetectorRef
  ){}

  public ngOnInit() {
    this.userInfoService.getUserDetails();
    this.getAccessToken();
    this.getBreakdownData();
  }

  public getAccessToken() {
    const data = {
      client_id: environment.AMLINE_CLIENT_ID,
      client_secret: environment.AMLINE_CLIENT_SECRET,
      grant_type: environment.AMLINE_GRANT_TYPE,
      scope: environment.AMLINE_SCOPE,
    };

    // get auth details
    this.breakdownService.getAccessToken(data)
      .subscribe((response: any) => {
        if (response.access_token) {
          this.authDetails = response;
          this.getStaticData(response);
        }
      });
  }

  public getStaticData(response) {
    this.breakdownService
      .getStaticData(response)
      .subscribe((response: any) => {
        if (response.meta) {
          this.staticData = response.meta;
        }
      });
  }

  public tabChanged(index: number) {
    this.selectedIndex = index;
    this.cd.detectChanges();
  }

  public getBreakdownData(id = '') {
    const quote_id = id || this.route.snapshot.params.id || null;

    if (!quote_id) return;

    this.breakdownService.getBreakdownData(quote_id)
      .subscribe(
        (response: any) => {
          if (response.result) {
            const data = response.result.quote;

            this.apiModelObject = data;

            const quoteType = Number(this.route.snapshot.params.quote_type);
            const isPolicy = Number(data.is_policy) === 1;
            const isMtaOrCancel = quoteType === 3 || quoteType === 4;

            if (isMtaOrCancel && isPolicy && !this.originalPolicyId) {
              this.originalPolicyId = data.id;
            }

            const isInitialPolicyLoad = isMtaOrCancel && isPolicy && !id;

            if (isInitialPolicyLoad) {
              this.modelObject = Object.assign({}, data);
              this.modelObject.id = null;
              this.modelObject.oldPolicyId = this.originalPolicyId;
              (this.modelObject as any).old_policy_id = this.originalPolicyId;
              this.modelObject.type = quoteType;
            } else {
              this.modelObject = data;
              if (isMtaOrCancel && this.originalPolicyId) {
                this.modelObject.oldPolicyId = this.originalPolicyId;
                (this.modelObject as any).old_policy_id = this.originalPolicyId;
                this.modelObject.type = quoteType;
              }
            }

            if (data.status == "referred") {
              this.router.navigate(['/breakdown/quote-details/', this.route.snapshot.params.id]);
            }
          }
        },
        (error) => {}
      );

  }

  modelObjectUpdated(data) {
    this.modelObject = null;
    this.modelObject = data;
    if (this.originalPolicyId) {
      this.modelObject.oldPolicyId = this.originalPolicyId;
      (this.modelObject as any).old_policy_id = this.originalPolicyId;
    }
    this.getBreakdownData(data.id);
    this.selectedIndex += 1;
  }
}
